import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import classnames from 'classnames';
import FieldInput from '../../../../common/components/FieldInput';
import ButtonsSubmitCancel from '../ButtonsSubmitCancel';
import FormTitle from "../FormTitle";
import FieldSelect from '../../../../common/components/FieldSelect';
import FieldCheckbox from '../../../../common/components/FieldCheckbox';
import FieldTextareaAutosize from "../../../../common/components/FieldTextareaAutosize";
import ModalSharedFilesList from "../../../../common/components/ModalSharedFilesList";
import AutoAcceptInteract from '../AutoAcceptInteract';
import MultipleTooltip from '../../../../common/components/MultipleTooltip';
import UploadingFilePopUp from "../../../../common/components/UploadingFilePopUp/UploadingFilePopUp";
import {limitFloatValueLength} from '../../../../common/utils/form/limitValueLength';
import styles from './styles.module.scss';

const Form_5View = ({
                      values,
                      prevPagePath,
                      nextPagePath,
                      options,
                      fileUploaded,
                      onFileSelected,
                      fileTypeIds,
                      showUploadingFilePopUp,
                      progress,
                      stepData,
                      shumaID,
                      stepID,
                      shumaTypeID,
                      fileSelectOptions: {
                        dedicatedAreaMap
                      },
                      propertyType: {
                        isRegular,
                        isGroundOrLot,
                        isLot,
                        isGround
                      },
                      setFieldValue
                    }) => {

  return (
    <div className={styles.form_5}>
      <FormTitle title={'שטחי הנכס'}/>
      <Form>
        <div className={styles.unit_1}>
          <h3 className={styles.marginBottom25}>קרקע</h3>
          <FieldTextareaAutosize
            fieldId={'landShetachText'}
            value={values.landShetachText}
            label={
              <div className={styles.labelWrapper}>
                <span>שטח מגרש</span>
                <MultipleTooltip
                  id={'areaLimitsTooltip'}
                  customIconClassName={styles.tooltip}
                  label={'יש לציין את מקור השטח'}
                />
              </div>
            }
            containerCustomStyles={styles.marginBottom25}
          />
          {(shumaTypeID !== 3 && shumaTypeID !== 4) &&
          <>
            <FieldCheckbox
              fieldId="landFront"
              label="חזית"
              value={values.landFront}
              containerStyles={classnames(styles.marginBottom25, styles.landFront)}
            />
            {values.landFront &&
            <FieldSelect
              fieldId="landDirection"
              mandatoryMark={true}
              label={'כיוון'}
              options={options.landDirectionOptions}
              containerStyles={classnames(styles.halfField, styles.marginBottom25)}
            />
            }
          </>
          }
          {(shumaTypeID !== 3 && shumaTypeID !== 4) &&
          <div className={styles.marginBottom25}>
            <h4 className={styles.buttonsSubheader}>
              קובץ מפת ייעודי סביבה
            </h4>
            <div className={styles.autoAcceptInteract}>
              {dedicatedAreaMap.type &&
              <>
                <ModalSharedFilesList file={dedicatedAreaMap} shumaID={shumaID} stepID={stepID}/>
                <div className={styles.divideLine}/>
              </>
              }
              <AutoAcceptInteract
                fieldId="dedicatedAreaMapFileUploaded"
                separateTabLink={stepData.gisLink}
                fileUploaded={fileUploaded.dedicatedAreaMapFileUploaded}
                onFileSelected={onFileSelected(fileTypeIds.dedicatedAreaMap)()}
                showModalApiButton={Boolean(stepData.apiExists)}
                showLinkButton={Boolean(stepData.gisLink)}
                setFieldValue={setFieldValue}
              />
            </div>
          </div>
          }
        </div>
        {!isGroundOrLot && (
          <div className={styles.unit_2}>
            <h3 className={styles.marginBottom25}>הבניין</h3>
            <div className={classnames(
              styles.marginBottom25,
              styles.quarterField
            )}>
              <FieldSelect
                fieldId="buildingJointHome"
                mandatoryMark={true}
                label={'בית משותף'}
                options={options.buildingJointHomeOptions}
              />
            </div>
          </div>
        )}
        <div className={styles.unit_3}>
          <h3 className={styles.marginBottom25}>הנכס הנבדק</h3>
          {!isLot && (
            <div>
              <h3 className={styles.marginBottom25}>שטח רשום</h3>
              <div className={classnames(styles.marginBottomLow, styles.flexBetween)}>
                <FieldSelect
                  fieldId="houseJointHomeRegistered"
                  mandatoryMark={true}
                  label={'רישום בית משותף'}
                  options={options.houseJointHomeRegisteredOptions}
                  containerStyles={styles.quarterField}
                />
                {(values.houseJointHomeRegistered && values.houseJointHomeRegistered.value === 1) &&
                <FieldInput
                  fieldId="houseRegisteredArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseRegisteredArea}
                  mandatoryMark={true}
                  label={(
                    <div>
                      <span>שטח רשום</span>
                      <span> (1)</span>
                    </div>
                  )}
                  containerCustomStyles={styles.quarterField}
                />
                }
                {(values.houseJointHomeRegistered && values.houseJointHomeRegistered.value === 1) &&
                <FieldInput
                  fieldId="houseBalconyOpenRegisteredArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseBalconyOpenRegisteredArea}
                  label={'שטח מרפסות פתוחות'}
                  containerCustomStyles={styles.quarterField}
                />
                }
                {(values.houseJointHomeRegistered && values.houseJointHomeRegistered.value === 1) &&
                <FieldInput
                  fieldId="houseBalconyClosedRegisteredArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseBalconyClosedRegisteredArea}
                  label={'שטח מרפסות סגורות'}
                  containerCustomStyles={styles.quarterField}
                />
                }
              </div>
              {(values.houseJointHomeRegistered && values.houseJointHomeRegistered.value === 1) &&
              <div className={classnames(styles.halfField, styles.flexEnd, styles.marginBottom25)}>
                <div className={classnames(styles.checkboxesContainer, styles.flexBetween)}>
                  <FieldCheckbox
                    fieldId="houseRegisteredAreaIncludeBalcony"
                    label="כולל מרפסת"
                    value={values.houseRegisteredAreaIncludeBalcony}
                  />
                  <FieldCheckbox
                    fieldId="houseRegisteredAreaIncludeStorage"
                    label="כולל מחסן"
                    value={values.houseRegisteredAreaIncludeStorage}
                  />
                </div>
              </div>
              }
              {(values.houseJointHomeRegistered && values.houseJointHomeRegistered.value === 1) &&
              <div className={styles.flexBetween}>
                <FieldInput
                  fieldId="houseYardRegisteredArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseYardRegisteredArea}
                  label={'שטח חצר'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseStorageRegisteredArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseStorageRegisteredArea}
                  label={'שטח מחסן'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseRoofRegisteredArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseRoofRegisteredArea}
                  label={'שטח גג'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseParkingRegisteredArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseParkingRegisteredArea}
                  label={'שטח חנייה'}
                  containerCustomStyles={styles.quarterField}
                />
              </div>
              }
              {!(
                (isRegular || isGround) &&
                (!values.houseJointHomeRegistered?.value || values.houseJointHomeRegistered.value === 2)
              ) &&
                <FieldTextareaAutosize
                  fieldId={'registeredAreaAdditionalDescription'}
                  value={values.registeredAreaAdditionalDescription}
                  label={'פירוט נוסף לשטח רשום'}
                  containerCustomStyles={classnames(styles.marginTop, styles.marginBottom25)}
                />
              }
              <h3 className={classnames(styles.marginBottom25, styles.marginTop)}>שטח ברישוי</h3>
              <div className={classnames(styles.flexBetween, styles.threeQuartersRow, styles.marginBottomLow)}>
                <FieldInput
                  fieldId="housePermitArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.housePermitArea}
                  label={'שטח ברישוי'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseMainArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseMainArea}
                  label='שטח עיקרי'
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseServiceArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseServiceArea}
                  label='שטח שרות'
                  containerCustomStyles={styles.quarterField}
                />
              </div>
              <div className={classnames(styles.quarterField, styles.flexEnd)}>
                <div className={classnames(
                  styles.checkboxesContainer,
                  styles.marginBottom25,
                  styles.flexBetween
                )}>
                  <FieldCheckbox
                    fieldId="housePermitAreaIncludeBalcony"
                    label="כולל מרפסת"
                    value={values.housePermitAreaIncludeBalcony}
                  />
                  <FieldCheckbox
                    fieldId="housePermitAreaIncludeStorage"
                    label="כולל מחסן"
                    value={values.housePermitAreaIncludeStorage}
                  />
                </div>
              </div>
              <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
                <FieldInput
                  fieldId="houseBalconyOpenPermitArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseBalconyOpenPermitArea}
                  label={'שטח מרפסות פתוחות'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseBalconyClosedPermitArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseBalconyClosedPermitArea}
                  label={'שטח מרפסות סגורות'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseYardPermitArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseYardPermitArea}
                  label={'שטח חצר'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseStoragePermitArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseStoragePermitArea}
                  label={'שטח מחסן'}
                  containerCustomStyles={styles.quarterField}
                />
              </div>
              <div className={classnames(
                styles.flexBetween,
                styles.marginBottom25,
                styles.halfField
              )}>
                <FieldInput
                  fieldId="houseRoofPermitArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseRoofPermitArea}
                  label={'שטח גג'}
                  containerCustomStyles={styles.quarterField}
                />
                <FieldInput
                  fieldId="houseParkingPermitArea"
                  onChange={limitFloatValueLength(6)}
                  value={values.houseParkingPermitArea}
                  label={'שטח חנייה'}
                  containerCustomStyles={styles.quarterField}
                />
              </div>
              <FieldTextareaAutosize
                fieldId="housePermitAreaText"
                value={values.housePermitAreaText}
                label='פירוט נוסף לשטח ברישוי'
                containerCustomStyles={styles.marginBottom25}
              />
              {(shumaTypeID === 3 || shumaTypeID === 4) &&
              <FieldTextareaAutosize
                fieldId="propertyAreaByRule9"
                value={values.propertyAreaByRule9}
                label="שטח הנכס לפי תקן 9"
                containerCustomStyles={styles.marginBottom25}
              />
              }
              {(shumaTypeID === 3 || shumaTypeID === 4) &&
              <FieldTextareaAutosize
                fieldId="propertyAreaByMunicipal"
                value={values.propertyAreaByMunicipal}
                label="שטח הנכס לפי ארנונה"
                containerCustomStyles={styles.marginBottom25}
              />
              }
            </div>
          )}
          <FieldTextareaAutosize
            fieldId="houseAreaAccordingTasritMeher"
            value={values.houseAreaAccordingTasritMeher}
            label='שטח בהתאם לתשריט מכר'
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="houseAreaAccordingHeskemShituf"
            value={values.houseAreaAccordingHeskemShituf}
            label='שטח בהתאם לתשריט הסכם שיתוף'
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="houseAreaAccordingTasritTaba"
            value={values.houseAreaAccordingTasritTaba}
            label='שטח בהתאם לתשריט תב”ע'
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="houseAreaAccordingTasritHahira"
            value={values.houseAreaAccordingTasritHahira}
            label='שטח בהתאם לתשריט חכירה'
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="houseAreaAccordingNesahRishum"
            value={values.houseAreaAccordingNesahRishum}
            label='שטח בהתאם לנסח הרישום (מפנקס הזכויות)'
            containerCustomStyles={styles.marginBottom25}
          />
        </div>
        <ButtonsSubmitCancel
          prevPagePath={prevPagePath}
          nextPagePath={nextPagePath}
        />
      </Form>
      <UploadingFilePopUp
        showUploadingFilePopUp={showUploadingFilePopUp}
        progress={progress}
        message="הקובץ נטען, אנא המתינו"
      />
    </div>
  );
};

Form_5View.propTypes = {
  values: PropTypes.object,
  prevPagePath: PropTypes.string,
  nextPagePath: PropTypes.string,
  options: PropTypes.shape({
    buildingJointHomeOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number
    })),
    houseJointHomeRegisteredOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number
    })),
    landDirectionOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number
    })),
  }),
  fileUploaded: PropTypes.object,
  onFileSelected: PropTypes.func,
  fileTypeIds: PropTypes.object,
  showUploadingFilePopUp: PropTypes.bool,
  progress: PropTypes.number,
  stepData: PropTypes.object,
  shumaID: PropTypes.number,
  stepID: PropTypes.number,
  shumaTypeID: PropTypes.number,
  fileSelectOptions: PropTypes.shape({
    dedicatedAreaMap: PropTypes.shape({
      type: PropTypes.string,
      fileTypeId: PropTypes.number,
      onSubmit: PropTypes.func,
    }),
  }).isRequired,
  propertyType: PropTypes.shape({
    isRegular: PropTypes.bool,
    isGroundOrLot: PropTypes.bool,
    isLot: PropTypes.bool,
    isGround: PropTypes.bool,
  })
};

export default Form_5View;
